import { createFileRoute } from '@tanstack/react-router';
import CompanyDocumentRequestDetails from '@/modules/document-requests/pages/company-document-request-details';
import { getGetDocumentRequestQueryOptions } from '@area-restrita/api-client/endpoints/document-request/document-request.gen';
import { z } from 'zod';

export const Route = createFileRoute(
  '/_authenticated/_system/_company/my-document-requests/$documentRequestId',
)({
  head: () => ({
    meta: [{ title: 'Detalhes da Solicitação de Documento' }],
  }),
  parseParams: z.object({
    documentRequestId: z.coerce.number(),
  }).parse,
  loader: async ({
    params: { documentRequestId },
    context: { queryClient },
  }) => {
    const documentRequest = await queryClient.ensureQueryData(
      getGetDocumentRequestQueryOptions(documentRequestId),
    );

    return documentRequest;
  },
  component: function CompanyDocumentRequestDetailsRoute() {
    const documentRequest = Route.useLoaderData();

    return <CompanyDocumentRequestDetails documentRequest={documentRequest} />;
  },
});
